
import Vue from "vue";
import isEqual from "lodash/isEqual";
import store from "@/store";
import { APPLICATION } from "@/store/applications";
import { UI } from "@/store/ui";
import { createNamespacedHelpers } from "vuex";
import { IApplicationState } from "@/store/applications/types";
import { CANCELLABLE_STATUSES, EDITABLE_STATUSES } from "@/constants/applicationStatuses";

const { mapGetters, mapState } = createNamespacedHelpers(APPLICATION.NAME_SPACE);

export default Vue.extend({
  computed: {
    canSave(): boolean {
      return this.hasChanges && !this.isLoading && this.isValid;
    },
    isLoading(): boolean {
      const uiIsloading = this.$store.state.ui.isLoading;
      return uiIsloading || this.$store.state.application.isLoading;
    },
    hasChanges(): boolean {
      const changes = store.state.application.applicationData;
      const original = store.state.application.applicationDataOriginal;

      return !isEqual(original, changes);
    },
    isValid(): boolean {
      const isValid = Object.keys(this.validity).every(
        key => this.validity[key] === true
      );
      return isValid;
    },
    isEditable(): boolean {
      return (
        this.isLoading ||
        EDITABLE_STATUSES.includes((this as any).applicationStatus)
      );
    },
    canCancel(): boolean {
      return (
        this.isLoading ||
        CANCELLABLE_STATUSES.includes((this as any).applicationStatus)
      );
    },
    ...mapState({
      applicationId: (state: IApplicationState) =>
        state && state.applicationData && state.applicationData.id,
      applicationName: (state: IApplicationState) =>
        state.applicationData &&
        state.applicationData.businessDetails &&
        state.applicationData.businessDetails.businessName,
      applicationStatus: (state: IApplicationState) =>
        state.applicationData && state.applicationData.status,
      cancellationReason: (state: IApplicationState) =>
        state.applicationData && state.applicationData.cancellationReason
    }),
    ...mapGetters([APPLICATION.GETTERS.IS_EDITABLE])
  },
  data() {
    return {
      validity: {} as any,
      showCancelApplicationDialog: false
    };
  },
  methods: {
    setValidity(key: string, valid: boolean) {
      Vue.set(this.validity, key, valid);
    },
    onSaveChanges() {
      const applicationData = store.state.application.applicationData;

      this.$store.dispatch(
        APPLICATION.NS(APPLICATION.ACTIONS.UPDATE_APPLICATION),
        { id: applicationData && applicationData.id, applicationData }
      );
    },
    onCancelChanges() {
      const originalData = store.state.application.applicationDataOriginal;

      this.$store.commit(
        APPLICATION.NS(APPLICATION.MUTATIONS.SET_APPLICATION_DATA),
        originalData
      );
    },
    onCancelApplication() {
      this.showCancelApplicationDialog = true;
    }
  }
});
